import React, { useState } from 'react';
import { TruckGroupSelectionModal } from 'app/entities/alert/components/TruckGroupSelectionModal';
import { FormControlDefault, TextFieldForms, TypographyForms } from 'app/shared/layout/register/DefaultFormsComponents';

interface Props {
  selectedGroupIds: number[];
  onChange: (ids: number[]) => void;
  disabled?: boolean;
}

export const TruckGroupSelectionField = ({ selectedGroupIds, onChange, disabled = false }: Props) => {
  const [open, setOpen] = useState(false);
  const selectedCount = selectedGroupIds?.length ?? 0;

  return (
    <>
      <FormControlDefault variant="outlined" sx={{ my: 0, width: '100%' }}>
        <TypographyForms variant="body2">Grupos de ativos</TypographyForms>
        <TextFieldForms
          value={
            selectedCount > 0
              ? `${selectedCount} grupo${selectedCount === 1 ? '' : 's'} associado${selectedCount === 1 ? '' : 's'}`
              : disabled
              ? 'Nenhum grupo associado'
              : 'Clique para associar grupos'
          }
          onClick={() => {
            if (!disabled) setOpen(true);
          }}
          disabled={disabled}
          InputProps={{ readOnly: true }}
          inputProps={{ 'aria-label': 'Selecionar grupos de ativos' }}
          sx={{
            cursor: disabled ? 'default' : 'pointer',
            '& .MuiInputBase-root, & .MuiInputBase-input': { cursor: disabled ? 'default' : 'pointer' },
          }}
        />
      </FormControlDefault>

      {open && (
        <TruckGroupSelectionModal
          open={open}
          toggleModal={() => setOpen(false)}
          initialSelectedGroupIds={selectedGroupIds}
          handleSave={onChange}
        />
      )}
    </>
  );
};
